
/* injects from baggage-loader */

import Helpers from "../../helpers/helperFunctions";
import { t } from "../translator";

export const handleGameMarketsListSubscriptionData = (data, gameId) => {
    if (Object.keys(data.sport).length !== 0) {
        let markets = {},
            Sport = data.sport,
            Region = Helpers.firstElement(Sport).region,
            Competition = Helpers.firstElement(Region).competition,
            Game = Helpers.firstElement(Competition).game;
        Helpers.objectToArray(Game[gameId].market).sort((a, b) => a.order - b.order).forEach((market) => {
            !markets[(market.group_name || t("Other Markets"))] ? markets[(market.group_name || t("Other Markets"))] = {} : null;
            !markets[(market.group_name || t("Other Markets"))][market.name] ? markets[(market.group_name || t("Other Markets"))][market.name] = [] : null;
            markets[(market.group_name || t("Other Markets"))][market.name] ? markets[(market.group_name || t("Other Markets"))][market.name].push(market) : null;
        });
        return markets;
    }
};

export const getGameSubscriptionData = (gameData, gameId) => {
    let data = {},
        Sport = Helpers.firstElement(gameData.sport),
        Region = Helpers.firstElement(Sport.region),
        Competition = Helpers.firstElement(Region.competition),
        Game = Competition.game[gameId];
    data.sportName = Sport.name;
    data.regionName = Region.name;
    data.competitionName = Competition.name;
    data.team1_name = Game.team1_name;
    data.team2_name = Game.team2_name;
    data.is_tf = Game.is_tf;
    data.video_provider = Game.video_provider;
    data.tv_type = Game.tv_type;
    data.video_id = Game.video_id;
    data.video_id3 = Game.video_id3;
    data.type = Game.type;
    data.partner_video_id = Game.partner_video_id;
    data.info = Game.info;
    data.last_event = Game.last_event;
    data.stats = Game.stats;
    data.is_neutral_venue = Game.is_neutral_venue;
    data.start_ts = Game.start_ts;
    data.text_info = Game.text_info;
    data.id = Game.id;
    data.is_stat_available = Game.is_stat_available;
    return data;
};